export default __webpack_public_path__ + "static/media/flutterwave_logo_color.41c1f5c7.svg";